export default __webpack_public_path__ + "static/Errorception-ae1f9fcce98ee0cf04f2d9c8ee7c9684.png";